import de from './de.json'
import en from './en.json'
import fr from './fr.json'
import it from './it.json'

export default {
  de,
  en,
  fr,
  it,
}